import React,{useState,createContext, useEffect} from 'react';
import axios from 'axios';

export const HomePageContext = createContext();

const HomePageContextProvider = (props) =>{
    const [homepagedata,setHomePageData]=useState();

    useEffect(()=>{
        getHomePageData();
    },[])

    const getHomePageData = async () =>{
        await axios({
            method:'get',
            url:`${process.env.REACT_APP_API_BASE_URL}/home`,
            headers: {
              'Authorization': `${process.env.REACT_APP_HEADER_TOKEN}`
            }
          })
          .then((response)=>{
            setHomePageData(response.data)
          })
          .catch((err)=>{
            console.log(err)
          })
    }

    return(
        <HomePageContext.Provider value={{homepagedata,setHomePageData}}>
            {props.children}
        </HomePageContext.Provider>
    )
}

export default HomePageContextProvider;